import { render, staticRenderFns } from "./dkzhuyao.vue?vue&type=template&id=27fb2b19&scoped=true&"
import script from "./dkzhuyao.vue?vue&type=script&lang=js&"
export * from "./dkzhuyao.vue?vue&type=script&lang=js&"
import style0 from "./dkzhuyao.vue?vue&type=style&index=0&id=27fb2b19&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb2b19",
  null
  
)

export default component.exports